import DgOverlay from "./Overlay.vue";

DgOverlay.install = Vue => {
  Vue.component(DgOverlay.name, DgOverlay);
};

export default DgOverlay;
